<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>夏季休業のお知らせ</h3>
      <br>

      <p>
        誠に勝手ながら、下記の期間を夏季休業とさせていただきます。<br>
        お客様にはご不便をお掛けしますが、何卒ご理解のほどお願い申し上げます。
      </p>

      <p>
      -------------------------------------<br>
      夏季休業日：2026年8月11日(火) ～ 8月16日(日)<br>
      -------------------------------------<br>
      </p>

      <p>
        ・ご注文・ランプ交換について
      </p>

      <p>
      -------------------------------------<br>
      ■化粧品・消耗品・美顔器：2026年8月10日(月)<br>
	14時までのご注文<br>
　	当日出荷<br>
      -------------------------------------<br>
      </p>

      <p>
      -------------------------------------<br>
      ■ランプ交換等：2026年8月10日(月)<br>
	午前中到着分<br>
　	当日出荷<br>
	※内容により当日対応が出来かねる場合もございます。<br>
      -------------------------------------<br>
      </p>

	 <p>
        上記以降のご注文・お問い合わせは8月17日(月)以降順次対応させていただきます。<br>
        ご迷惑をお掛け致しますが、何卒ご了承いただきますようお願い申し上げます。
      </p>


      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news251226',
  props: {
    largescreen: {
      type: Boolean
    }
  },
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>